<template>
	<div class="d-flex flex-column h-100">
		<header class="masthead mb-auto">
			<nav class="navbar navbar-expand-lg navbar-dark bg-no-trans ">
				<div class="container">
					<a class="navbar-brand" href="/#/">
						<img src="../../assets/img/logo.png" alt="Logo" />
					</a>
					<div class="my-2 my-lg-0">
						<button
							class="btn btn-light btn-sm my-2 my-sm-0"
							@click="gotoSingin"
						>
							Login
						</button>
					</div>
				</div>
			</nav>
		</header>

		<section
			class="login-container height-auto py-5 bg-grey200 flex-shrink-0 container-fluid"
		>
			<form class="form-signin card mt-4 bg-light">
				<h5 class="text-center mb-3">Verify Phone</h5>
				<div class="form-group text-center ">
					<img src="../../assets/img/sent.svg" width="40" alt="" />
				</div>
				<div class="form-group">
					<p class="text-green text-center">
						Enter the verification code sent to <br />{{ this.regNum }} to
						continue
					</p>
				</div>
				<div class="form-group">
					<div class="input-group verify">
						<input
							class="form-control"
							v-on:keyup="$event.target.nextElementSibling.focus()"
							maxlength="1"
							v-model="dataCode.one"
						/>
						<input
							class="form-control"
							v-on:keyup="$event.target.nextElementSibling.focus()"
							maxlength="1"
							v-model="dataCode.two"
						/>
						<input
							class="form-control"
							v-on:keyup="$event.target.nextElementSibling.focus()"
							maxlength="1"
							v-model="dataCode.three"
						/>
						<input
							class="form-control"
							v-on:keyup="$event.target.nextElementSibling.focus()"
							maxlength="1"
							v-model="dataCode.four"
						/>
						<input
							class="form-control"
							v-on:keyup="$event.target.nextElementSibling.focus()"
							maxlength="1"
							v-model="dataCode.five"
						/>
						<input class="form-control" maxlength="1" v-model="dataCode.six" />
					</div>
				</div>
				<button
					class="btn btn-primary btn-block text-uppercase mt-3"
					v-on:click.stop.prevent="verifyPhone"
				>
					VERIFY
				</button>
				<small class="text-center pt-3" v-if="showCountDown">
					Resend a new code in
					<span class="count-down-text"
						>00:<span v-if="countDownSeconds < 10">0</span
						>{{ countDownSeconds }}
					</span>
				</small>
				<small class="text-center pt-3" v-if="!showCountDown && showResendCode"
					>Didn’t receive a verification code?
					<a v-on:click.stop.prevent="sendSms" class="cursor-pointer"
						>Resend code
					</a>
				</small>

				<small class="text-center pt-3" v-if="!showCountDown">
					If you don’t get the code in 60 seconds, please
					<a @click="goToContactUs" class="cursor-pointer">
						Contact us
					</a>
				</small>

				<div class="alert-box-1 mb-4" v-if="showOtpError">
					<p>
						Sorry, we can’t update profile for wrong OTP. Please try again.
					</p>
				</div>
			</form>
			<p class="text-center pt-4">Download App</p>
			<p class="text-center ">
				<img
					src="../../assets/img/google-play.png"
					alt=""
					class="cursor-pointer"
					@click="gotoAppStore('google')"
				/>
				<img
					src="../../assets/img/app-store.png"
					class="ml-2 cursor-pointer"
					alt=""
					@click="gotoAppStore('apple')"
				/>
			</p>
		</section>
		<div
			v-if="showContactus"
			class="notfound-container d-flex flex-column h-100"
		>
			<section class="col-md-6 contact-container">
				<div class="form-upgrade card">
					<div class="row">
						<div class="col-md-12">
							<div class="upgrade-heading">
								<h2 class="py-4 heading">
									Didn’t receive a verification code?
								</h2>
							</div>
							<div class="upgrade-plan py-3">
								<p>
									Please Contact our support team to help with your need
								</p>
								<div class="buttons">
									<a @click="goToContactUs" class="btn btn-primary btn-lg ">
										Contact us
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</div>
		<footer class="footer text-dark mt-auto py-3 bg-grey200">
			<div class="container text-center">
				<a href="/#/">Home</a>
				<a href="/#/cookiesprivacy">Privacy Policy</a>
				<a href="/#/terms">Terms of Use</a>
				<a href="/#/faqs">FAQ</a>
			</div>
			<div class="footer-copyright text-center py-2">
				Copyright © 2021. All Rights Reserved by IBAKA Entertainment Inc.
			</div>
		</footer>
	</div>
</template>

<style scoped>
.cursor-pointer {
	cursor: pointer;
}

.py-5 {
	padding-top: 8rem !important;
	padding-bottom: 8rem !important;
	min-height: 100vh !important;
}
.upgrade-plan > p {
	padding-top: 0px;
	padding-bottom: 10px;
	margin-top: 0px;
	margin-bottom: 0px;
	font-size: 20px;
	text-align: center;
	display: flex !important;
	justify-content: center !important;
}
.upgrade-heading {
	display: flex !important;
	justify-content: center !important;
}

.heading {
	display: flex !important;
	justify-content: center !important;
}

.notfound-container {
	content: "";
	position: absolute;
	left: 0;
	top: 0;
	display: block;
	width: 100%;
	min-height: 100vh;
	background-blend-mode: overlay;
	background-color: rgba(103, 159, 61, 0.88);
}
.card {
	border-radius: 20px;
}
.buttons {
	display: flex !important;
	justify-content: center !important;
	padding-bottom: 30px;
	padding-top: 30px;
}
.contact-container {
	margin: auto;
}
.count-down-text {
	color: #679f3d;
}
</style>

<script>
export default {
	name: "verifyByPhone",
	components: {},
	created() {
		this.$store.commit("showdefaultFooter", false);
		this.$store.commit("showdefaultnav", false);
		this.token = this.$route.query.token;
		this.email = this.$route.query.uid;
		if (this.$store.state.user.regmobile == null) {
			this.$router.push("/");
		} else {
			this.regNum = this.$store.state.user.regmobile;
		}
		this.otpTriggerAttempt = this.$store.getters.getGlobalConfigs.otpTriggerAttempt;
		this.otpAttempt = this.$store.getters.getSmsTriggerAttempt;
		if(this.$store.getters.getShowOtpTimer == true){
			this.showCountDown =true;
			this.startCountDown();
			this.$store.commit("setShowOtpTimer",false);
		}
		
	},

	methods: {
		sendSms() {
			this.otpAttempt = this.$store.getters.getSmsTriggerAttempt;
			this.otpAttempt = this.otpAttempt + 1;
			this.$store.commit("setSmsTriggerAttempt", this.otpAttempt);
			if (this.otpAttempt <= this.otpTriggerAttempt) {
				this.showCountDown = true;
				this.startCountDown();
				var dataToSend = {
					telephone: this.regNum,
				};
				this.$store
					.dispatch("triggerSMSverify", dataToSend)
					.then((res) => {
						if (res) {
							this.$store.commit("setNotification", res.message);
							this.$store.commit("setLoader", false);
						}
					})
					.catch((err) => {
						this.$store.commit("setLoader", false);
						this.$store.commit(
							"setNotification",
							err.response.data.error.message
						);
					});
			} else {
				this.showResendCode = false;
			}
		},
		gotoAppStore(type) {
			if (type == "google") {
				window.open(
					"https://play.google.com/store/apps/details?id=com.ibakatv.mobile",
					"_blank"
				);
			} else if (type == "apple") {
				window.open(
					"https://apps.apple.com/gm/app/ibakatv/id1060646446",
					"_blank"
				);
			}
		},
		goToPackage() {
			this.$router.push("/packages");
		},
		gotoSingin() {
			this.$store.commit("logoutUser");
			this.$router.push("/login");
		},
		goToContactUs() {
			this.$router.push("/contact");
		},
		verifyPhone() {
			var self = this;
			var verificationCode =
				this.dataCode.one +
				this.dataCode.two +
				this.dataCode.three +
				this.dataCode.four +
				this.dataCode.five +
				this.dataCode.six;
			this.$store.commit("setLoader", true);
			this.$store
				.dispatch("verifySMS", {
					telephone: this.regNum,
					code: verificationCode,
				})
				.then((res) => {
					self.$store.commit("setNotification", res.message);
					self.$store.commit("setLoader", false);
					this.showOtpError = false;
					setTimeout(function() {
						self.$router.push("/packages");
					}, 5000);
				})
				.catch((err) => {
					self.$store.commit("setNotification");
					this.showOtpError = true;
					self.$store.commit("setLoader", false);
				});
		},
		startCountDown() {
			this.countDownHandle = setInterval(() => {
				this.countDownSeconds--;
				if (this.countDownSeconds <= 0) {
					this.countDownSeconds = 60;
					clearInterval(this.countDownHandle);
					this.showCountDown = false;
					if (this.otpAttempt < this.otpTriggerAttempt) {
						this.showResendCode = true;
					}
				}
			}, 1000);
		},
	},

	data() {
		return {
			regNum: "",
			dataCode: {
				one: "",
				two: "",
				three: "",
				four: "",
				five: "",
				six: "",
			},
			token: "",
			email: "",
			phone: "",
			textfloating: "",
			successMsg: false,
			bgImg: "https://www.ibakatv.com/_nuxt/img/62cf189.jpg",
			showOtpError: false,
			otpAttempt: 0,
			otpTriggerAttempt: null,
			showContactus: false,
			showCountDown: false,
			countDownSeconds: 60,
			countDownHandle: null,
			showResendCode: true,
		};
	},
};
</script>
